import {FC} from 'react'
import {Button} from '../Button/Button'

interface ICompletedActionsProps {
  registrationClickHandler: () => void
  playAgainClickHandler: () => void
  text: string
  storeWinnersData: boolean
  isGrillQuiz?: boolean
}

export const CompletedActions: FC<ICompletedActionsProps> = ({
  registrationClickHandler,
  playAgainClickHandler,
  text,
  storeWinnersData,
  isGrillQuiz = false,
}) => {
  return (
    <div className="flex max-w-[354px] flex-col items-center justify-center text-center text-white">
      {storeWinnersData && (
        <>
          <h3 id="thanks-text" className="mb-[4px] text-[24px] uppercase">
            Takk for at du deltok
          </h3>
          <p id="registration-description" className="mb-[16px] px-[24px] text-[20px]">
            {text}
          </p>
          <Button
            id="registration-btn"
            color={isGrillQuiz ? "orange" : "purple"}
            size="small"
            fullWidth
            onClick={registrationClickHandler}
          >
            Registrer deg
          </Button>
          <div className="align-center my-[16px] flex w-full flex-1 flex-row items-center gap-[8px]">
            <div className="flex h-[2px] w-full flex-1 bg-[linear-gradient(to_right,rgba(255,255,255,0),#fff)]" />
            <div className="uppercase text-white">Eller</div>
            <div className="flex h-[2px] w-full flex-1 bg-[linear-gradient(to_left,rgba(255,255,255,0),#fff)]" />
          </div>
        </>
      )}
      <Button
        id="play-again-btn"
        color={isGrillQuiz ? "orange" : "blue"}
        size="small"
        fullWidth
        onClick={playAgainClickHandler}
      >
        Spill igjen
      </Button>
      <Button
        className="mt-4"
        id="redirect-to-coop"
        color={isGrillQuiz ? "orange" : "blue"}
        size="small"
        fullWidth
        onClick={() => window.open('https://www.coop.no/')}
      >
        Gå til Coop.no
      </Button>
    </div>
  )
}
